import React from 'react';
import SamuraiGame from '../SamuraiGame';

const BillDrill = () => {
    return <SamuraiGame initialDrillIndex={2} />;
};

export default BillDrill;
